var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "post-list" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm._l(_vm.posts, function (post, index) {
            return [
              _c("transition", { key: post.ID, attrs: { name: "fade" } }, [
                index < _vm.postsNumer
                  ? _c(
                      "a",
                      {
                        key: post.ID,
                        staticClass: "post-list__item",
                        attrs: { href: post.url },
                      },
                      [
                        _c("span", {
                          staticClass: "post-list__item__image",
                          style: {
                            "background-image": "url(" + post.thumbnail + ")",
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "post-list__item__title",
                          domProps: { innerHTML: _vm._s(post.post_title) },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "post-list__item__readmore" },
                          [_vm._v("Read more")]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm.postsNumer < _vm.posts.length
          ? _c(
              "div",
              {
                staticClass: "post-list__loadmore",
                on: {
                  click: function ($event) {
                    _vm.postsNumer += _vm.postsPerPage
                  },
                },
              },
              [_vm._v("Load more")]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }